import type { GridDensity } from '@mui/x-data-grid-pro';
import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export type PreferredAreaUnit = 'ha' | 'section';

type IntelUIState = {
  isMapHidden: boolean;
  bottomTableHeight: number;
  isLegendHidden: boolean;
  enableIndividualMapSelections: boolean;
  preferredAreaUnits: PreferredAreaUnit;
  tableDensity: GridDensity;
  isAreaDialogOpen: boolean;
  isExportMode: boolean;
};

const isMapVisibleOnLoad = !window.location.search.includes('hide_map=true');

const initialState: IntelUIState = {
  isMapHidden: !isMapVisibleOnLoad,
  bottomTableHeight: 444,
  isLegendHidden: false,
  enableIndividualMapSelections: true,
  preferredAreaUnits: 'section',
  tableDensity: 'standard',
  isAreaDialogOpen: false,
  isExportMode: false,
};

const createIntelUiSlice = (sliceName: string) =>
  createSlice({
    name: sliceName,
    initialState,
    reducers: {
      show: (state) => {
        state.isMapHidden = false;
      },
      hide: (state) => {
        state.isMapHidden = true;
      },
      toggleMap: (state) => {
        state.isMapHidden = !state.isMapHidden;
      },
      toggleLegend: (state) => {
        state.isLegendHidden = !state.isLegendHidden;
      },
      setPreferredAreaUnits: (
        state,
        { payload }: PayloadAction<PreferredAreaUnit>
      ) => {
        state.preferredAreaUnits = payload;
      },
      changeTableDensity: (state, { payload }: PayloadAction<GridDensity>) => {
        state.tableDensity = payload;
      },
      toggleIndividualMapSelections: (state) => {
        state.enableIndividualMapSelections =
          !state.enableIndividualMapSelections;
      },
      setBottomTableHeight: (state, { payload }: PayloadAction<number>) => {
        state.bottomTableHeight = payload;
      },
      openAreaDialog: (state) => {
        state.isAreaDialogOpen = true;
      },
      closeAreaDialog: (state) => {
        state.isAreaDialogOpen = false;
      },
      enterExportMode: (state) => {
        state.isExportMode = true;
      },
      exitExportMode: (state) => {
        state.isExportMode = false;
      },
    },
  });

export const intelUiSlice = createIntelUiSlice('intel-ui');
